export const HIDE_TIMEOUT = 2500;
